interface CommentItem {
  id: string;
  news_id: string;
  name: string;
  email: string;
  comment: string;
  approved: boolean;
  created_at: string;
  news?: { title: string };
}

interface Props {
  notifications: CommentItem[];
  isEmpty: boolean;
  onGoToComments: () => void;
  onApprove: (id: string) => void;
}

function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Az önce';
  if (mins < 60) return `${mins} dk önce`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} sa önce`;
  return `${Math.floor(hrs / 24)} gün önce`;
}

export default function CommentNotificationPanel({ notifications, isEmpty, onGoToComments, onApprove }: Props) {
  return (
    <div className="absolute right-0 top-12 w-80 bg-white rounded-2xl border border-gray-100 z-50 overflow-hidden"
      style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-gray-50">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 flex items-center justify-center bg-orange-100 rounded-lg">
            <i className="ri-notification-3-line text-orange-500 text-sm" />
          </div>
          <span className="text-sm font-bold text-[#0A0E27]">Yorum Bildirimleri</span>
        </div>
        <button
          onClick={onGoToComments}
          className="text-xs text-[#0A0E27]/50 hover:text-[#0A0E27] transition-colors cursor-pointer whitespace-nowrap font-medium"
        >
          Tümünü Gör
        </button>
      </div>

      {/* Content */}
      <div className="max-h-80 overflow-y-auto">
        {isEmpty ? (
          <div className="flex flex-col items-center justify-center py-10 text-gray-300">
            <div className="w-12 h-12 flex items-center justify-center bg-gray-50 rounded-full mb-3">
              <i className="ri-chat-check-line text-2xl" />
            </div>
            <p className="text-sm text-gray-400 font-medium">Bekleyen yorum yok</p>
            <p className="text-xs text-gray-300 mt-1">Tüm yorumlar onaylandı</p>
          </div>
        ) : (
          <div className="flex flex-col divide-y divide-gray-50">
            {notifications.map(notif => (
              <div key={notif.id} className="px-4 py-3 hover:bg-gray-50 transition-colors">
                <div className="flex items-start gap-3">
                  {/* Avatar */}
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full flex-shrink-0 mt-0.5">
                    <span className="text-orange-600 text-xs font-black">
                      {notif.name.charAt(0).toUpperCase()}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2 mb-0.5">
                      <span className="text-xs font-bold text-[#0A0E27] truncate">{notif.name}</span>
                      <span className="text-[10px] text-gray-400 flex-shrink-0">{timeAgo(notif.created_at)}</span>
                    </div>
                    {notif.news && (
                      <p className="text-[10px] text-gray-400 mb-1 truncate">
                        <i className="ri-newspaper-line mr-0.5" />{notif.news.title}
                      </p>
                    )}
                    <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed">{notif.comment}</p>

                    {/* Actions */}
                    {!notif.approved && (
                      <div className="flex items-center gap-2 mt-2">
                        <button
                          onClick={() => onApprove(notif.id)}
                          className="flex items-center gap-1 bg-green-50 text-green-700 border border-green-200 rounded-lg px-2.5 py-1 text-[10px] font-bold hover:bg-green-100 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-check-line" />Onayla
                        </button>
                        <span className="text-[10px] bg-orange-50 text-orange-600 border border-orange-200 px-2.5 py-1 rounded-lg font-bold">
                          Bekliyor
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
        <button
          onClick={onGoToComments}
          className="w-full flex items-center justify-center gap-1.5 text-xs font-bold text-[#0A0E27] hover:text-[#0A0E27]/70 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-chat-3-line" />Yorum Moderasyonuna Git
          <i className="ri-arrow-right-line" />
        </button>
      </div>
    </div>
  );
}
